module.exports = __webpack_public_path__ + "static/media/split,_alaksa.083040b2.png";